import { Play, Clapperboard, Music4, Link2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { VIDEOS } from "../data/videos";

export default function Videos() {
  return (
    <section id="videos" data-testid="videos-section" className="halftone relative border-t-2 border-ink bg-banana/30 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <span className="sticker rotate-1 rounded-lg bg-white">
            <Clapperboard className="h-3.5 w-3.5" /> Lights, camera, cousins
          </span>
          <h2 className="mt-5 max-w-2xl font-head text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
            Watch &amp; listen to the cousins <span className="text-maroon">in action.</span>
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-ink/70 sm:text-lg">
            Press play and meet Lil Momma and Man-Man — on the field, on the mat, on a spooky Halloween night, and in
            song.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2">
          {VIDEOS.map((v, i) => (
            <Reveal key={v.name} delay={i * 0.12}>
              <article
                data-testid={v.testid}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white shadow-pop transition-all duration-300 hover:-translate-y-1.5 hover:shadow-pop-lg"
              >
                <div className="relative border-b-2 border-ink bg-ink">
                  <video
                    data-testid={`${v.testid}-player`}
                    controls
                    preload="none"
                    playsInline
                    poster={v.poster}
                    className="aspect-video w-full object-cover"
                  >
                    <source src={v.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <span
                    className="sticker pointer-events-none absolute left-3 top-3 flex -rotate-2 items-center gap-1.5 rounded-full text-[10px]"
                    style={{ backgroundColor: v.color, color: "#FFFDF6" }}
                  >
                    <Play className="h-3 w-3 fill-current" /> Watch
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-head text-lg font-extrabold tracking-tight">{v.name}</h3>
                  <p className="mt-1.5 flex-1 text-sm leading-relaxed text-ink/70">{v.desc}</p>
                  <Link
                    data-testid={`${v.testid}-share-link`}
                    to={`/videos/${v.slug}`}
                    className="mt-4 inline-flex w-fit items-center gap-1.5 font-mono text-xs font-bold uppercase tracking-widest text-royal underline-offset-4 transition-colors hover:text-maroon hover:underline"
                  >
                    <Link2 className="h-3.5 w-3.5" /> Share this video
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.36}>
            <article
              data-testid="audio-lil-momma-song"
              className="group relative flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-maroon shadow-pop transition-all duration-300 hover:-translate-y-1.5 hover:shadow-pop-lg"
            >
              <div className="relative flex-1 overflow-hidden border-b-2 border-ink">
                <img
                  src="/videos/lil-momma-cheer-poster.jpg"
                  alt="Lil Momma cheer scene"
                  className="absolute inset-0 h-full w-full object-cover opacity-35 transition-transform duration-500 group-hover:scale-105"
                />
                <div className="relative flex min-h-56 flex-col items-center justify-center gap-4 p-8 text-center">
                  <span className="sticker flex -rotate-2 items-center gap-1.5 rounded-full bg-crimson text-[10px] text-cream">
                    <Music4 className="h-3 w-3" /> Listen
                  </span>
                  <p className="font-display text-2xl font-bold leading-snug text-cream drop-shadow-[2px_2px_0_rgba(0,0,0,0.4)] sm:text-3xl">
                    “LM Cheers” — the Lil Momma theme song
                  </p>
                  <p className="max-w-sm font-mono text-xs font-bold uppercase tracking-[0.25em] text-banana">
                    Sing along · 1 min 57 sec
                  </p>
                </div>
              </div>
              <div className="bg-cream p-5">
                <audio
                  data-testid="audio-lil-momma-player"
                  controls
                  preload="none"
                  className="w-full"
                  src="/audio/lil-momma-cheers.mp3"
                >
                  Your browser does not support the audio tag.
                </audio>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
